import router from './router'
import store from './store'
import {
	Message
} from 'element-ui'
import {
	getToken
} from '@/utils/auth'

// 没有token可访问名单
// const whiteList = ['/login', '/', '/shade','/news']

import axios from 'axios'

router.beforeEach((to, from, next) => {
	next()
	// if (getToken()) {
	// 	// 有token
	// 	console.log(to.path.indexOf('/kd') !== -1)
	// 	if (to.path.indexOf('/kd') !== -1) {
	// 		if (to.path === '/kdlogin') {
	// 			// 有token访问登录页或者注册页面，返回登录成功页面
	// 			next({
	// 				name: 'kdLogged'
	// 			})
	// 		} else {
	// 			// 有token访问其它页面的情况
	// 			if (store.getters.roles.length === 0) {
	// 				// 判断当前用户是否已拉取完user_info信息
	// 				store.dispatch('kdGetInfo').then(res => {

	// 						// 拉取user_info
	// 						// const roles = res.roles
	// 						// if (102 !== res.user.deptId) {
	// 						// 	store.dispatch('FedLogOut').then(() => {
	// 						// 		next({
	// 						// 			path: '/'
	// 						// 		})
	// 						// 	})
	// 						// } else {
	// 						// 	next()
	// 						// }
	// 						next()
	// 					})
	// 					.catch(err => {
	// 						store.dispatch('FedLogOut').then(() => {
	// 							Message.error(err)
	// 							next({
	// 								path: '/'
	// 							})
	// 						})
	// 					})
	// 			} else {
	// 				next()
	// 				// 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
	// 				// if (hasPermission(store.getters.roles, to.meta.roles)) {
	// 				//   next()
	// 				// } else {
	// 				//   next({ path: '/401', replace: true, query: { noGoBack: true }})
	// 				// }
	// 				// 可删 ↑
	// 			}
	// 		}
	// 	} else {
	// 		if (to.path === '/login' || to.path === '/register') {
	// 			// 有token访问登录页或者注册页面，返回登录成功页面
	// 			next({
	// 				name: 'Logged'
	// 			})
	// 		} else {
	// 			// 有token访问其它页面的情况
	// 			if (store.getters.roles.length === 0) {
	// 				// 判断当前用户是否已拉取完user_info信息
	// 				store.dispatch('GetInfo').then(res => {

	// 						// 拉取user_info
	// 						const roles = res.roles
	// 						// store.dispatch('GenerateRoutes', {
	// 						// 	roles
	// 						// }).then(accessRoutes => {
	// 						// 	// 测试 默认静态页面
	// 						// 	// store.dispatch('permission/generateRoutes', { roles }).then(accessRoutes => {
	// 						// 	// 根据roles权限生成可访问的路由表
	// 						// 	router.addRoutes(accessRoutes) // 动态添加可访问路由表
	// 						// 	next({ ...to,
	// 						// 		replace: true
	// 						// 	}) // hack方法 确保addRoutes已完成
	// 						// })
	// 						if (102 !== res.user.deptId) {
	// 							store.dispatch('FedLogOut').then(() => {
	// 								next({
	// 									path: '/'
	// 								})
	// 							})
	// 						} else {
	// 							next()
	// 						}

	// 					})
	// 					.catch(err => {
	// 						store.dispatch('FedLogOut').then(() => {
	// 							Message.error(err)
	// 							next({
	// 								path: '/'
	// 							})
	// 						})
	// 					})
	// 			} else {
	// 				next()
	// 				// 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
	// 				// if (hasPermission(store.getters.roles, to.meta.roles)) {
	// 				//   next()
	// 				// } else {
	// 				//   next({ path: '/401', replace: true, query: { noGoBack: true }})
	// 				// }
	// 				// 可删 ↑
	// 			}
	// 		}




	// 	}
	// } else {
	// 	// 如果是小升初登录，
	// 	// 获取时间判断->
	// 	// 显示遮罩 或者 跳转到登录页
	// 	// 没有token
	// 	if (to.path === '/login') {
	// 		axios.get("/prod-api-primary/shade").then(resp => {
	// 			// if (whiteList.indexOf(to.path) !== -1) {
	// 			if (resp.data.data) {
	// 				if (to.path === "/shade") {
	// 					next()
	// 				} else {
	// 					next("/shade")
	// 				}
	// 			} else {
	// 				if (to.path === "/shade") {
	// 					next(`/?redirect=${to.path}`) // 否则全部重定向到登录页
	// 				} else {
	// 					next()
	// 				}
	// 			}
	// 			// } else {
	// 			// 	next(`/?redirect=${to.path}`) // 否则全部重定向到登录页
	// 			// }
	// 		});
	// 	} else if (to.path === '/kdlogin') {
	// 		next()

	// 	} else {
	// 		if (to.path.indexOf('/logged') !== -1) {
	// 			next(`/?redirect=${to.path}`)
	// 		} else if (to.path.indexOf('/kdlogged') !== -1) {
	// 			next(`/?redirect=${to.path}`)
	// 		} else {
	// 			next()
	// 		}

	// 	}

	// 	// next()
	// }
})

router.afterEach(() => {})